<template>
  <vs-popup :title="popupTitle" :active.sync="showModal" class="w-full">
    <div class="w-full">
      <div class="flex justify-end">
        <a
          style="background-color: #14a577"
          class="flex items-center justify-center gap-4 w-48 h-10 rounded-lg text-white cursor-pointer mb-6"
          @click.prevent="uploadPopup = true"
        >
          {{ $t("UploadAttachment")
          }}<i class="material-icons notranslate"> cloud_upload </i>
        </a>
      </div>
      <data-grid
        v-if="showGrid"
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('AttachmentType') },
          { title: $t('File') },
          { title: $t('Action') },
        ]"
      >
        <template slot-scope="{ row }">
          <td style="width: 20%">
            {{ translateFileType(row.fileType) }}
          </td>
          <td style="width: 60%">
            <div class="w-full flex justify-center">
              <!-- img and file -->
              <span v-if="row.fileType == 4" style="font-size: 2rem">
                <a
                  class="ma-2"
                  outlined
                  :href="URLS_CONSTANTS.assets + 'Contents/' + row.fileUrl"
                  download
                >
                  <i class="material-icons" style="font-size: 7rem">
                    description
                  </i>
                </a>
              </span>
              <img
                v-else
                :src="URLS_CONSTANTS.assets + 'Contents/' + row.fileUrl"
                style="max-height: 100px"
                class="rounded cursor-pointer"
                @click.prevent="
                  showImagePopup(
                    URLS_CONSTANTS.assets + 'Contents/' + row.fileUrl
                  )
                "
              />
            </div>
          </td>
          <td style="width: 20%">
            <div>
              <vs-button
                @click="removeImage(row.fileType)"
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                class="d-inline"
              ></vs-button>
            </div>
          </td>
        </template>
      </data-grid>
      <upload-popup
        :show="uploadPopup"
        @close="uploadPopup = false"
        @success="renderGrid"
        :attachmentTypes="attachmentTypes"
        :contentItemId="modelToEdit.id"
      >
      </upload-popup>
      <ImagePopup
        v-if="imagePopup"
        :show="imagePopup"
        :image="selectedImage"
        @close="imagePopup = false"
      ></ImagePopup>
    </div>
  </vs-popup>
</template>

<script>
import { URLS_CONSTANTS } from "@/../config";
import myUpload from "vue-image-crop-upload";
import DataGrid from "@/components/datagrid/DataGrid";
import UploadPopup from "./UploadPopup.vue";
import ImagePopup from "@/components/ImagePopup.vue";

import { mapActions } from "vuex";
export default {
  props: {
    show: { default: false },
    modelToEdit: { default: null },
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  data() {
    return {
      popupTitle: "",
      attachmentTypes: [
        { label: "عکس کاور", id: 1 },
        { label: "عکس کاور موبایل", id: 2 },
        { label: "عکس آیکون", id: 3 },
        // { label: "فایل", id: 4 },
      ],
      gridDataSource: {
        type: "app",
        service: "",
      },
      gridSearchData: {
        keyword: "",
      },
      uploadPopup: false,
      URLS_CONSTANTS,
      imagePopup: false,
      selectedImage: "",
      showGrid: false,
    };
  },
  components: {
    myUpload,
    DataGrid,
    UploadPopup,
    ImagePopup,
  },
  methods: {
    ...mapActions({
      removeContentItemAttachment: "contentType/deleteContentItemAttachment",
    }),
    translateFileType(fileType) {
      switch (fileType) {
        case 1:
          return "کاور";
        case 2:
          // code block
          return "کاور موبایل";
        case 3:
          // code block
          return "آیکون";
        case 4:
          // code block
          return "فایل";
      }
    },
    removeImage(fileType) {
      const payload = {
        contentId: Number(this.$route.params.id),
        type: fileType,
        contentItemId: this.modelToEdit.id,
      };
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeContentItemAttachment(payload).then((response) => {
            if (response) {
              this.renderGrid();
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت حذف شد!",
                showConfirmButton: false,
                timer: 2000,
              });
            }
          });
        }
      });
    },
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 500);
    },
    showImagePopup(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.popupTitle = "پیوست‌های آیتمِ " + this.modelToEdit.title;
        this.gridDataSource.service = `/CMS/api/ContentImageQuery?contentId=${Number(
          this.$route.params.id
        )}&contentItemId=${this.modelToEdit.id}&`;
        this.showGrid = true;
      } else {
        this.showGrid = false;
      }
    },
  },
};
</script>

<style scoped></style>
